import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';
import { GALLERY_DEFAULT_FETCH_ORDER, Order, ResourceType } from '../common/typings';
import { changeRecentOrder, GalleryAction, previewAudioItem } from '../GalleryPane/actions';
import { getCommonGalleryDispatchToProps } from '../GalleryPane/helpers';
import { selectCurrentGallery, selectEmptyGalleryPanesMap, selectRecentGalleryPane } from '../GalleryPane/selectors';
import { GalleryPaneTypes, PreviewAudioItemParams } from '../GalleryPane/typings';

import { CanvasAudioGallery, CanvasAudioGalleryProps } from './CanvasAudioGallery';

export type StateProps = TStateProps<CanvasAudioGalleryProps>;
export type DispatchProps = TDispatchProps<CanvasAudioGalleryProps>;

const mapDispatchToProps = (dispatch: Dispatch<GalleryAction>): DispatchProps => {
    const commonDispatchProps = getCommonGalleryDispatchToProps(dispatch);

    return {
        ...commonDispatchProps,

        previewAudioItem: (pane: GalleryPaneTypes, params?: PreviewAudioItemParams): void => {
            dispatch(previewAudioItem(pane, params));
        },

        // фильтры
        changeRecentOrder: (order: Order) => {
            dispatch(changeRecentOrder(order));
        }
    };
};

export const mapStateToProps = (state: State): StateProps => {
    const { galleries } = state.canvasEditor.canvas;
    const { isPopupOpened, currentResourceType, error } = galleries;

    const { currentPaneType, enabledGalleryTypes, preview, isBusy } = selectCurrentGallery(galleries);

    let recentOrder = GALLERY_DEFAULT_FETCH_ORDER;
    const { data } = galleries.resources[ResourceType.audio].panes[currentPaneType];

    if (enabledGalleryTypes.includes(GalleryPaneTypes.recent)) {
        const recentFilters = selectRecentGalleryPane(galleries).filters;

        recentOrder = recentFilters.recentOrder;
    }

    return {
        isBusy,
        currentPaneType,
        isPopupOpened: isPopupOpened && currentResourceType === ResourceType.audio,
        enabledGalleryTypes,
        error,
        emptyGalleriesMap: selectEmptyGalleryPanesMap(galleries, ResourceType.audio),
        preview,
        recentOrder,
        currentPaneCollection: data.collection
    };
};

export const CanvasAudioGalleryContainer = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(CanvasAudioGallery);
